import { ReactElement, useMemo } from 'react';

import { useSubscriptionFeatures } from '~hooks/index';

import AccessFeatureBadge from '../Badge';
import ListField from '../../ListField';

import { AccessFeatureListFielddProps } from './types';

const AccessFeatureListField = ({
  validFeature,
  availableToDate,
  showChip = true,
  openAccessFeatureModalOnClickChip,
  disabled: disabledProps,
  ...rest
}: AccessFeatureListFielddProps): ReactElement => {
  const { hasAccessToFeature } = useSubscriptionFeatures();

  const disabled = useMemo(
    () => disabledProps || !hasAccessToFeature(validFeature, availableToDate),
    [disabledProps, hasAccessToFeature, validFeature, availableToDate],
  );

  const openModalOnClickChip = useMemo(
    () => disabledProps ?? openAccessFeatureModalOnClickChip,
    [disabledProps, openAccessFeatureModalOnClickChip],
  );

  return (
    <AccessFeatureBadge
      validFeature={validFeature}
      availableToDate={availableToDate}
      fullWidth
      openAccessFeatureModalOnClickChip={openModalOnClickChip}
      showChip={showChip}
      translateY={0}
    >
      <ListField disabled={disabled} {...rest} />
    </AccessFeatureBadge>
  );
};

export default AccessFeatureListField;
